import { render, staticRenderFns } from "./Bus20.vue?vue&type=template&id=1bb541aa&scoped=true&"
import script from "./Bus20.vue?vue&type=script&lang=js&"
export * from "./Bus20.vue?vue&type=script&lang=js&"
import style0 from "./Bus20.vue?vue&type=style&index=0&id=1bb541aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb541aa",
  null
  
)

export default component.exports